<ng-template #template>
  <div class="svc-flex-column">
    <svc-toolbox *ngIf="model.isToolboxVisible" [model]="creator"></svc-toolbox>
  </div>
  <div class="svc-tab-designer" [class]="model.getRootCss()" (click)="model.clickDesigner()">
    <sv-scroll>
      <div class="svc-tab-designer_content">
        <ng-container *ngIf="model.showPlaceholder">
          <div *ngIf="creator.showHeaderInEmptySurvey && creator.allowEditSurveyTitle" class="svc-designer-header">
            <div *ngIf="survey.renderedHasHeader" [class]="survey.css.header" [survey]="survey" sv-ng-survey-header>
            </div>
          </div>
          <div class="svc-designer__placeholder-container" [attr.data-sv-drop-target-survey-element]="'newGhostPage'">
            <svc-surface-placeholder [name]="'designer'" [placeholderTitleText]="model.placeholderTitleText"
              [placeholderDescriptionText]="model.placeholderDescriptionText">
            </svc-surface-placeholder>
            <div class="svc-designer-placeholder-page">
              <svc-page [model]="model.newPage" [survey]="survey" [creator]="creator" [isGhost]="true"></svc-page>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!model.showPlaceholder">
          <svc-designer-survey [model]="model"></svc-designer-survey>
        </ng-container>
      </div>
    </sv-scroll>
  </div>
</ng-template>